module.exports = __webpack_public_path__ + "static/img/video_poster.f523172.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video_poster.png
// module id = W4TW
// module chunks = 0